import { render, staticRenderFns } from "./exchanger.vue?vue&type=template&id=1c4a87a2&scoped=true&"
import script from "./exchanger.vue?vue&type=script&lang=js&"
export * from "./exchanger.vue?vue&type=script&lang=js&"
import style0 from "./exchanger.vue?vue&type=style&index=0&id=1c4a87a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a87a2",
  null
  
)

export default component.exports